/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum QaCheckFrequencyType {
  None = 'None',
  Minutes = 'Minutes',
  Container = 'Container',
  ProcessingUnit = 'ProcessingUnit',
  Order = 'Order'
}
